import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const categoryColors = {
  Events: "text-teal-400 bg-teal-400/10",
  Impact: "text-cyan-400 bg-cyan-400/10",
  Announcements: "text-purple-400 bg-purple-400/10",
};

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(console.error);
  }, []);

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-NG", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <section id="blog" data-testid="blog-section" className="py-24 md:py-32 bg-zinc-900/30">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="section-label">Blog & News</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4 mb-4 max-w-2xl">
          Latest <span className="gradient-text">updates</span>
        </h2>
        <p className="text-zinc-400 text-base sm:text-lg mb-16 max-w-xl leading-relaxed">
          Stay informed about our events, community impact, and technology advocacy efforts.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 stagger-children">
          {posts.map((post) => (
            <article
              key={post.id}
              className="blog-card bg-zinc-900 border border-zinc-800 p-6 flex flex-col group cursor-pointer"
              data-testid={`blog-post-${post.id}`}
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className={`text-[10px] uppercase tracking-[0.2em] font-semibold px-2.5 py-1 ${
                    categoryColors[post.category] || "text-zinc-400 bg-zinc-800"
                  }`}
                >
                  {post.category}
                </span>
                <ArrowUpRight size={16} className="text-zinc-600 group-hover:text-teal-400 transition-colors" />
              </div>
              <h3 className="text-lg font-bold text-white tracking-tight mb-3 group-hover:text-teal-300 transition-colors">
                {post.title}
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed mb-4 flex-1">{post.excerpt}</p>
              <div className="flex items-center justify-between text-xs text-zinc-500">
                <span>{post.author}</span>
                <span>{formatDate(post.date)}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
